import React, { useState } from "react";
import { Box } from "@mui/material";

const CustomScrollContainer = ({ 
    children, 
    sx, 
    component = 'div',
    hoverScrollbar = true,
    showHorizontal = true,
    showVertical = true,
    scrollbarSize = '6px',
    scrollbarThumbColor = '#c1c1c1',
    scrollbarTrackColor = 'transparent',
    scrollbarHoverColor = '#a8a8a8',
    scrollbarActiveColor = '#888',
    borderRadius = '10px',
    transitionDuration = '0.3s',
    ...props 
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const getScrollbarStyles = () => {
        const styles = {
            '&::-webkit-scrollbar': {
                height: showHorizontal ? (hoverScrollbar ? (isHovered ? scrollbarSize : '0px') : scrollbarSize) : '0px',
                width: showVertical ? (hoverScrollbar ? (isHovered ? scrollbarSize : '0px') : scrollbarSize) : '0px',
                transition: `height ${transitionDuration} ease, width ${transitionDuration} ease`,
            },
            '&::-webkit-scrollbar-track': {
                background: scrollbarTrackColor,
                borderRadius: borderRadius,
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: isHovered ? scrollbarThumbColor : 'transparent',
                borderRadius: borderRadius,
                border: '2px solid transparent',
                backgroundClip: 'padding-box',
                '&:hover': {
                    backgroundColor: scrollbarHoverColor,
                }
            },
            '&::-webkit-scrollbar-thumb:active': {
                backgroundColor: scrollbarActiveColor,
            },
            // Firefox support
            scrollbarWidth: isHovered ? 'thin' : 'none',
            scrollbarColor: isHovered ? `${scrollbarThumbColor} ${scrollbarTrackColor}` : 'transparent transparent',
        };

        return styles;
    };

    return (
        <Box
            component={component}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            sx={{
                overflow: 'auto',
                position: 'relative',
                ...getScrollbarStyles(),
                ...sx,
            }}
            {...props}
        >
            {children}
        </Box>
    );
};

export default CustomScrollContainer;